// @flow

export default {
  appTitle: "Dev Candidate Lightbox - Lonely Planet",
  appDescription: "An exquisite lightbox",
  appIcon: "/logo.png",
  appLogo: "/logo.png",
  appLogoWidth: "256",
  appLogoHeight: "256",
  colorTheme: "#297cbb",
};



// WEBPACK FOOTER //
// ./src/etc/variables.js